import React, { Component } from 'react'
import axios from 'axios'

import Bygg from './Bygg.jsx'
import BygningsendringList from './BygningsendringList.jsx';
import BygningsstatusHistorikkList from './BygningsstatusHistorikkList.jsx';
import EtasjeList from './EtasjeList.jsx';
import KontaktpersonList from './KontaktpersonList.jsx';
import MatrikkelenhetList from './MatrikkelenhetList.jsx';
import SefrakminneList from './SefrakminneList.jsx';
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'

class ByggDetails extends Component {
    state = {
        bygg: null
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (this.state.bygg == null) return
        if (nextProps.byggId == this.state.bygg.byggId) return

        this.setState({bygg: null})
    }

    componentDidMount = () => {
        this.getBygg()
    }

    shouldComponentUpdate = (nextProps, nextState) => {
        var currentByggId = null;
        if (this.state.bygg != null) currentByggId = this.state.bygg.byggId

        var byggId = null
        if (nextState.bygg != null) byggId = nextState.bygg.byggId

        if (currentByggId != byggId) return true
        return false
    }

    componentDidUpdate = () => {
        if (this.state.bygg == null || this.state.bygg.byggId != this.props.byggId) this.getBygg()
    }

    getBygg = () => {
        axios.get(`${this.props.settings.baseUrl}api/bygg/${this.props.byggId}`, {
            params: {
                token: this.props.token
            }
        })
        .then(({data}) => {
            this.setState({bygg: data})
            this.props.onEvent({
                type: MatrikkelSearchEvents.SelectBygg,
                data: {
                    bygg: data
                }
            })
            this.props.onEvent({
                type: MatrikkelSearchEvents.ZoomToObject,
                data: {
                    type: MatrikkelSearchEvents.ShowBygg,
                    bygg: data
                }
            })
        })
      }

    render() {
        if (this.state.bygg == null) return (<div className="spinner"><i className="fa fa-spinner fa-spin"></i></div>)
        var bygg = this.state.bygg
        return (
            <ul className="resultdetails">
                <Bygg bygg={bygg} token={this.props.token} onEvent={this.props.onEvent} />
                { bygg.antallBygningsendringer > 0 && <BygningsendringList byggId={bygg.byggId} antall={bygg.antallBygningsendringer} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} /> }
                { bygg.antallBygningsstatusHistorikker > 0 && <BygningsstatusHistorikkList byggId={bygg.byggId} antall={bygg.antallBygningsstatusHistorikker} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} /> }
                { bygg.antallEtasjer > 0 && <EtasjeList byggId={bygg.byggId} antall={bygg.antallEtasjer} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} /> }
                { bygg.antallKontaktpersoner > 0 && <KontaktpersonList byggId={bygg.byggId} antall={bygg.antallKontaktpersoner} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} /> }
                { bygg.antallMatrikkelenheter > 0 && <MatrikkelenhetList byggId={bygg.byggId} antall={bygg.antallMatrikkelenheter} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.props.onMatrikkelObjectSelected} /> }
                { bygg.antallSefrakminner > 0 && <SefrakminneList byggId={bygg.byggId} antall={bygg.antallSefrakminner} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} /> }
            </ul>
        )
    }
}

export default ByggDetails